
import { User } from '../auth/User';
//Need a new user type for this?

import { ApiRoutes, getFullApiRoute, replaceRouteParams } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';

export class CompanyUserAPI {
    //Get all user of a company
    static async getAll(user: User, tenantId?: string): Promise<object[]> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.COMPANY_USERS), {"id": tenantId ?? user.attributes.tenant_id}),
            'GET',
            null,
            null,
            user
        );
        return result?.data || [];
    }

    //Get a single user of a company by query param - this should be in the user api but it is not there yet
    //TODO: This should already exist in the user api
    static async getOne(user:User, companyUserId: string) : Promise<object> {
        const result = await HttpRequest(
            getFullApiRoute(ApiRoutes.USERS)+`?id=${companyUserId}`,
            'GET',
            null,
            null,
            user
        );
        //Check if we have a result and if it is object or array, if array just retun the first item as that is what we expect
        return result && result.data ? (Array.isArray(result.data) ? result.data[0] : result.data) : {};
    }
}
